import * as React from 'react';
import { getColor } from '../../pages/training/helper';
import { getOrdinalSuffix } from './utils';

import './percentileGauge.scss';

export interface PercentileGaugeProps {
	percentile: number;
	rankingText?: string | null;
}

const ARC_CENTER_X = 106;
const ARC_CENTER_Y = 100;
const ARC_RADIUS = 80;
const ARC_LENGTH = Math.PI * ARC_RADIUS;
const ARC_START_X = ARC_CENTER_X - ARC_RADIUS;
const ARC_END_X = ARC_CENTER_X + ARC_RADIUS;
const ARC_PATH = `M ${ARC_START_X} ${ARC_CENTER_Y} A ${ARC_RADIUS} ${ARC_RADIUS} 0 0 1 ${ARC_END_X} ${ARC_CENTER_Y}`;
const VIEWBOX_WIDTH = 212;
const VIEWBOX_HEIGHT = 110;
const TICK_RIGHT_X = 210;

const PercentileGauge: React.FunctionComponent<PercentileGaugeProps> = ({ percentile, rankingText }) => {
	const clampedPercentile = Math.max(0, Math.min(1, percentile));
	const value = Math.round(clampedPercentile * 100);
	const progressLength = clampedPercentile * ARC_LENGTH;
	const progressColor = getColor(value);
	const ordinalLabel = `${value}${getOrdinalSuffix(value)}`;

	return (
		<div className="percentile-gauge">
			<div className="percentile-gauge_chart">
				<svg viewBox={`0 0 ${VIEWBOX_WIDTH} ${VIEWBOX_HEIGHT}`}>
					<path
						d={ARC_PATH}
						fill="none"
						className="percentile-gauge_track"
						strokeLinecap="round"
						strokeWidth="10"
					/>
					{progressLength > 0 && (
						<path
							d={ARC_PATH}
							fill="none"
							stroke={progressColor}
							strokeDasharray={`${progressLength} ${ARC_LENGTH}`}
							strokeLinecap="round"
							strokeWidth="10"
						/>
					)}
					<text className="percentile-gauge_tick" x="12" y="108">
						0
					</text>
					<text className="percentile-gauge_tick" textAnchor="end" x={TICK_RIGHT_X} y="108">
						100
					</text>
				</svg>
				<div className="percentile-gauge_center">
					<span className="percentile-gauge_ordinal" style={{ color: progressColor }}>
						{ordinalLabel}
					</span>
					<span className="percentile-gauge_percentile-label">Percentile</span>
				</div>
			</div>
			<div className="percentile-gauge_scale">
				<span>Lowest</span>
				<span>Highest</span>
			</div>
			{rankingText && (
				<div className="percentile-gauge_ranking" style={{ color: progressColor }}>
					{rankingText}
				</div>
			)}
			<p className="percentile-gauge_caption">Compared to your peer group</p>
		</div>
	);
};

export default PercentileGauge;
